import { useContext, useEffect, useRef, useState } from 'react';
import { WebApiContext } from 'ascendon-web-api';
import { translateFault, generateUnhandledFault } from '../../helpers/faults';

function useGrantCoupon() {
  const [fault, setFault] = useState(null);
  const [faultStatus, setFaultStatus] = useState(null);
  const [uiModel, setUiModel] = useState(null);
  const WebApi = useContext(WebApiContext);

  const isMounted = useRef(true);

  useEffect(
    () => () => {
      isMounted.current = false;
    },
    [],
  );

  const requestGrantCoupon = ({ newRequestData, headers }) => {
    const addedHeaders = [];
    const retentionData = ASCENDON_ENV_CONFIG.retentionConfiguration;

    const grantCouponUrl = `${retentionData?.retentionMicroserviceURL}/grant-coupon`;

    addedHeaders.push(
      { name: 'CD-SubscriberId', value: headers.subscriberId },
      { name: 'Content-Type', value: 'application/json' },
      { name: 'cache-control', value: 'no-cache' },
      {
        name: 'x-api-key',
        value: retentionData.retentionMicroserviceApiKey,
      },
    );
    WebApi.subscriber({
      customUrl: grantCouponUrl,
      keyFactors: ['retention'],
      forceRefresh: true,
      payload: newRequestData,
      headers: {
        add: addedHeaders,
      },
    })
      .then((response) => {
        setFaultStatus(false);
        if (isMounted.current) {
          setUiModel(response?.data);
        }
      })
      .catch((error) => {
        setFaultStatus((prevState) => !prevState);
        const code = error?.data?.Code;
        let errorMsg;
        if (!code) {
          const unknownFault = generateUnhandledFault(error.data);
          errorMsg = translateFault(unknownFault).translatedMessage;
          setFault(errorMsg);
        } else {
          errorMsg = translateFault(error.data).translatedMessage;
          setFault(errorMsg);
        }
      });
  };
  return [uiModel, fault, faultStatus, requestGrantCoupon];
}
export { useGrantCoupon };
export default useGrantCoupon;
